import React from "react";

import IBoundsContext from "@app/scene/map/components/TerritoriesMode/types/IBoundsContext";

const BoundsContext = React.createContext<IBoundsContext>({
  canChangeState: false,
  canRedo: false,
  canUndo: false,
  onRedo: () => {},
  onStartOver: () => {},
  onUndo: () => {},
  setCanChangeState: () => {},
  setCanRedo: () => {},
  setCanUndo: () => {},
  setColor: () => {},
  setListeners: () => {},
});

export default BoundsContext;
